module.exports = __webpack_public_path__ + "img/KarbalaRoad2.4e2740c7.jpg";